// Mutations
export const RAISE_ERROR = 'main.raise-error'
export const CLEAR_NOTIFICATION_MESSAGES = 'main.clear-error'
export const NOTIFY = 'main.notify'

// Constants
export const ERROR_MESSAGE = 'error'
export const SUCCESS_MESSAGE = 'success'
export const WARNING_MESSAGE = 'warning'
export const COMMON_MESSAGE = 'common'
